import type {
  CommunicationLanguage,
  Interrogatory,
  ViewCommunication,
  ViewCommunicationItem,
} from "@/briefpoint-client";
import ReviewClientTaskBox from "./ReviewClientTaskBox";

type DeleteInterrogatoryArg = {
  communicationId: string;
  interrogatoryId: number;
};

type ReviewClientTasksAssignedListProps = {
  documentId: string;
  language: CommunicationLanguage;
  activeCommunication: ViewCommunication | undefined;
  interrogatories: Interrogatory[];
  primaryTasksSorted: ViewCommunicationItem[];
  onDeleteInterrogatory: (arg: DeleteInterrogatoryArg) => void;
  onRequestDeleteWithModal: (item: ViewCommunicationItem) => void;
  onOpenTaskEditor: (item: ViewCommunicationItem) => void;
};

export default function ReviewClientTasksAssignedList(
  props: ReviewClientTasksAssignedListProps,
) {
  return (
    <>
      {props.primaryTasksSorted.map((externalCommunication) => (
        <ReviewClientTaskBox
          key={externalCommunication.id}
          communication={externalCommunication}
          language={props.language}
          interrogatories={props.interrogatories}
          removeInterrogatory={(interrogatoryId) => {
            props.onDeleteInterrogatory({
              communicationId: externalCommunication.id ?? "",
              interrogatoryId: Number(interrogatoryId),
            });
          }}
          setDeleteCommunication={props.onRequestDeleteWithModal}
          translatedCommunication={props.activeCommunication?.externalCommunicationItems?.find(
            (c) =>
              c.translatedExternalCommunicationItemId ===
              externalCommunication.id,
          )}
          documentId={props.documentId}
          setEditCommunication={props.onOpenTaskEditor}
        />
      ))}
    </>
  );
}
